import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// Debounced check of e-mail addresses against tenant recipients.
// Returns { conflicts: { <address>: {type,id,displayName} }, checking }.
export function useAddressCheck(addresses, excludeId) {
  const [conflicts, setConflicts] = useState({});
  const [checking, setChecking] = useState(false);
  const timer = useRef(null);
  const seq = useRef(0);
  const key = JSON.stringify(addresses);

  useEffect(() => {
    const list = (addresses || []).filter((a) => a && a.includes("@") && !a.endsWith("@"));
    if (timer.current) clearTimeout(timer.current);
    if (!list.length) { setConflicts({}); setChecking(false); return; }
    setChecking(true);
    const mine = ++seq.current;
    timer.current = setTimeout(() => {
      api.post("/recipients/check-addresses", { addresses: list, excludeId })
        .then((r) => { if (mine === seq.current) setConflicts(r.data.conflicts || {}); })
        .catch(() => { if (mine === seq.current) setConflicts({}); })
        .finally(() => { if (mine === seq.current) setChecking(false); });
    }, 500);
    return () => timer.current && clearTimeout(timer.current);
  }, [key, excludeId]); // eslint-disable-line react-hooks/exhaustive-deps

  return { conflicts, checking };
}
